import script from "./EditorSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorSlider.vue?vue&type=script&setup=true&lang=js"

import "./EditorSlider.vue?vue&type=style&index=0&id=5beced3a&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5beced3a"]])

export default __exports__